import {
    SIGNALR,
    SIGNALR_SET,
    SIGNALR_SET_SUCCESS,
    SIGNALR_SET_TRIGGER
} from "../actionType";

const INITIAL_STATE = {
    signalAchDelayedMsg: {},
    signalBankCalloutMsg: []
};

const theme = (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case SIGNALR:
            return {
                ...state,
            };

        case SIGNALR_SET_TRIGGER:
            return action.payload;
        case SIGNALR_SET_SUCCESS:
            return action.payload;
        default:
            return state;
    }
};
export default theme;